.liquidationHeader {
  display: flex;
}
